// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2213 ? "51fb665c" : chunkId) + "." + {"1029":"eae5f7bd47b195d0","2213":"c45caf89b2d44a24"}[chunkId] + ".js";
};